/* Dansk katalog for locale-superplumma-workspace.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Arbejd sammen med SuperPlumma i chatten, og se opgaven i arbejdsfladen.',
  'spw.eyebrow': 'Din regnskabsassistent',
  'spw.intro': 'Hvad skal vi lave i dag? Bed mig oprette en faktura, eller upload et bilag. Dokumentet vises her, mens vi arbejder med det.',
  'spw.upload': 'Upload bilag',
  'spw.camera': 'Tag billede',
  'spw.dropHint': 'Du kan også slippe et bilag her.',
  'spw.drop': 'Slip bilaget her',
  'spw.uploading': 'Uploader bilaget …',
  'spw.uploadError': 'Bilaget kunne ikke uploades.',
  'spw.saveDraft': 'Gem kladde',
  'spw.issued': 'Fakturaen er oprettet.',
  'spw.showProposal': 'Vis forslag',
  'spw.editDetails': 'Ret detaljer',
  'spw.addReceipt': 'Upload et bilag i chatten, eller tag et billede.',
  'spw.proposal': 'Forslag til bogføring',
  'spw.supplierMissing': 'Ingen leverandør valgt',
  'spw.account': 'Konto',
  'spw.vat': 'Moms',
  'spw.notSelected': 'Ikke valgt',
  'spw.readingHint': 'Forslaget vises, når bilaget er læst, eller detaljerne er udfyldt.',
  'spw.paymentAccount': 'Betalingskonto',
  'spw.unpaid': 'Ikke betalt',
  'spw.approvalHint': 'Bed SuperPlumma om at bogføre, når forslaget er klar. Du får mulighed for at kontrollere og godkende handlingen.',
  'spw.openTask': 'Åbn opgaven',
  'spw.chat': 'Chat',
  'spw.workspace': 'Arbejdsflade',
  'spw.shared': 'Samme regnskab. Fuldt overblik.',
  'spw.receipts': 'Bilagsføring',
  'spw.purchase': 'Køb',
  'spw.sale': 'Salg',
  'spw.invoice': 'Fakturakladde',
  'spw.choose': 'Vælg opgave',
  'spw.loading': 'Åbner arbejdsfladen …',
  'spw.loadError': 'Arbejdsfladen kunne ikke indlæses. Din samtale er bevaret.',
  'spw.retry': 'Prøv igen',
  'spw.unavailable': 'Åbn SuperPlumma i en aktiv virksomhed for at starte.',
  'spw.changeTitle': 'Skift opgave?',
  'spw.changeText': 'Gem eventuelle ændringer i formularen, før du skifter opgave. Ændringer, der ikke er gemt, kan gå tabt.',
  'spw.changeConfirm': 'Skift opgave',
});
